import { render } from "./comment.html?vue&type=template&id=6584fff4"
import script from "./Comment.vue?vue&type=script&lang=ts"
export * from "./Comment.vue?vue&type=script&lang=ts"

import "../../objects/byline/byline.scss?vue&type=style&index=0&lang=scss"
import "./comment.scss?vue&type=style&index=1&lang=scss"
script.render = render

export default script